<template>
  <sui-segment attached="bottom">
    <sui-table celled padded>
      <template v-for="(keys, type) in keysByType">
        <sui-table-header :key="`${type}-header`">
          <sui-table-row>
            <sui-table-header-cell colspan="5">{{type.toUpperCase()}} Public Keys</sui-table-header-cell>
          </sui-table-row>
        </sui-table-header>
        <sui-table-body :key="`${type}-body`" v-show="keys.length">
          <sui-table-row v-for="key in keys" :key="key.id">
            <sui-table-cell collapsing>
              <i class="icon" :class="type === 'ssh' ? 'key' : 'folder'" />&nbsp;{{type.toUpperCase()}}
            </sui-table-cell>
            <sui-table-cell>
              {{key.name}}<span v-show="key.default"> (default)</span>
            </sui-table-cell>
            <sui-table-cell collapsing>
              <sui-dropdown class="hosts-dropdown" :class="{disabled: !hostsByKey[key.id].length}" selection>
                <span class="text">used on {{pluralize('host', hostsByKey[key.id].length, true)}}</span>
                <sui-dropdown-menu>
                  <router-link class="item" :to="`/hosts/${host.name}`" v-for="host in hostsByKey[key.id]" :key="host.id">
                    <Logo :entity="host" />
                    {{host.name}}
                    <span class="description"><i class="arrow right icon" /></span>
                  </router-link>
                </sui-dropdown-menu>
              </sui-dropdown>
            </sui-table-cell>
            <sui-table-cell collapsing>
              <time class="meta">added {{momentFromNow(key.created)}}</time>
            </sui-table-cell>
            <sui-table-cell collapsing>
              <i class="trash link fitted icon" :class="{disabled: !access.keyDestroy}" @click="deleteKey(key)" />
            </sui-table-cell>
          </sui-table-row>
        </sui-table-body>
        <sui-table-body :key="`${type}-empty`" v-show="!keys.length">
          <sui-table-row>
            <sui-table-cell colspan="5">You haven't added any {{type.toUpperCase()}} keys yet</sui-table-cell>
          </sui-table-row>
        </sui-table-body>
      </template>
      <sui-table-footer>
        <sui-table-row>
          <sui-table-header-cell colspan="5">
            <sui-button color="green" size="small" icon="plus" label-position="left" :disabled="!access.keyCreate" @click.prevent="openKeyCreator()" data-goal="SETTINGS_KEYS_ADD">Add key</sui-button>
          </sui-table-header-cell>
        </sui-table-row>
      </sui-table-footer>
    </sui-table>
    <sui-message error v-if="apiErrors">
      {{apiErrors}}
    </sui-message>
  </sui-segment>
</template>

<script>
  import {mapGetters} from 'vuex'
  import utils from '@/utils'

  export default {
    name: 'SettingsKeysView',
    data() {
      return {
        apiErrors: null,
      }
    },
    computed: {
      ...mapGetters(['access', 'keys', 'keysByType', 'hostsByKey']),
    },
    methods: {
      deleteKey(key) {
        return this.$modals.confirm.open({
          callback: () => {
            this.apiErrors = null
            utils.reachGoal('SETTINGS_KEYS_DELETE_TRY')
            key.destroy().then(() => {
              utils.reachGoal('SETTINGS_KEYS_DELETE_SUCCESS')
            }).catch(error => {
              this.apiErrors = error
              utils.reachGoal('SETTINGS_KEYS_DELETE_FAIL')
            })
          },
        })
      },
      openKeyCreator() {
        this.$modals.createKey.open()
      },
    },
  }
</script>

<style scoped>
  .hosts-dropdown { border: none!important; margin: -1em; }
  .provider-logo { display: inline-block!important; margin: -1em 0!important; max-height: 2em!important; }
  .trash:hover { color: #c00; }
</style>
